import { useCallback, useEffect, useState } from 'react'
import { type EmblaCarouselType } from 'embla-carousel'

export const useEmblaDots = (emblaApi: EmblaCarouselType | undefined) => {
  const [selectedIndex, setSelectedIndex] = useState(0)

  const onDotClick = useCallback(
    (index: number) => {
      emblaApi?.scrollTo(index)
    },
    [emblaApi],
  )

  useEffect(() => {
    if (!emblaApi) {
      return
    }

    const onSelect = (api: EmblaCarouselType) => {
      setSelectedIndex(api.selectedScrollSnap())
    }

    onSelect(emblaApi)
    emblaApi.on('reInit', onSelect).on('select', onSelect)

    return () => {
      emblaApi.off('reInit', onSelect).off('select', onSelect)
    }
  }, [emblaApi])

  return { onDotClick, selectedIndex }
}
